// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* frontend/src/liveSessionBroadcast.css
 * Shared responsive layout for the two full-bleed Live Session pages
 * (student JoinLivePage, faculty HostLivePage) — these render outside the
 * dashboard chrome so they don't inherit AskosDashboard.css/.app-shell
 * breakpoints. Scoped under .live-broadcast-shell; breakpoint matches the
 * dashboard's existing tablet cutoff (900px) for consistency.
 */
.live-broadcast-shell .live-header {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    justify-content: space-between;
}

.live-broadcast-shell .live-body {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
}

.live-broadcast-shell .live-video-col {
    flex: 2 1;
    min-width: 280px;
}

.live-broadcast-shell .live-side-col {
    flex: 1 1;
    min-width: 260px;
}

/* Square, responsive video frame: scales with column width via aspect-ratio
 * instead of a fixed pixel height, capped so it doesn't get huge on wide
 * desktop screens. */
.live-broadcast-shell .live-video-frame {
    position: relative;
    width: 100%;
    max-width: 560px;
    aspect-ratio: 1 / 1;
    background: #061f43;
    border-radius: 12px;
    overflow: hidden;
    margin: 0 auto;
}

.live-broadcast-shell .live-video-frame > .live-video-target {
    width: 100%;
    height: 100%;
}

.live-broadcast-shell .live-video-placeholder {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    padding: 0 16px;
}

@media (max-width: 900px) {
    .live-broadcast-shell .live-body {
        flex-direction: column;
    }
    .live-broadcast-shell .live-video-col,
    .live-broadcast-shell .live-side-col {
        min-width: 0;
        width: 100%;
    }
    .live-broadcast-shell .live-video-frame {
        max-width: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/liveSessionBroadcast.css"],"names":[],"mappings":"AAAA;;;;;;EAME;AACF;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;AACb;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;;qBAEqB;AACrB;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;;QAEI,YAAY;QACZ,WAAW;IACf;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* frontend/src/liveSessionBroadcast.css\n * Shared responsive layout for the two full-bleed Live Session pages\n * (student JoinLivePage, faculty HostLivePage) — these render outside the\n * dashboard chrome so they don't inherit AskosDashboard.css/.app-shell\n * breakpoints. Scoped under .live-broadcast-shell; breakpoint matches the\n * dashboard's existing tablet cutoff (900px) for consistency.\n */\n.live-broadcast-shell .live-header {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n    justify-content: space-between;\n}\n\n.live-broadcast-shell .live-body {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px;\n}\n\n.live-broadcast-shell .live-video-col {\n    flex: 2;\n    min-width: 280px;\n}\n\n.live-broadcast-shell .live-side-col {\n    flex: 1;\n    min-width: 260px;\n}\n\n/* Square, responsive video frame: scales with column width via aspect-ratio\n * instead of a fixed pixel height, capped so it doesn't get huge on wide\n * desktop screens. */\n.live-broadcast-shell .live-video-frame {\n    position: relative;\n    width: 100%;\n    max-width: 560px;\n    aspect-ratio: 1 / 1;\n    background: #061f43;\n    border-radius: 12px;\n    overflow: hidden;\n    margin: 0 auto;\n}\n\n.live-broadcast-shell .live-video-frame > .live-video-target {\n    width: 100%;\n    height: 100%;\n}\n\n.live-broadcast-shell .live-video-placeholder {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    text-align: center;\n    padding: 0 16px;\n}\n\n@media (max-width: 900px) {\n    .live-broadcast-shell .live-body {\n        flex-direction: column;\n    }\n    .live-broadcast-shell .live-video-col,\n    .live-broadcast-shell .live-side-col {\n        min-width: 0;\n        width: 100%;\n    }\n    .live-broadcast-shell .live-video-frame {\n        max-width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
